export default {
  default: '/',
  signin: '/login',
  signup: '/signup',
  msSignin: '/ms_login',
  accountSetting: '/account-setting',
  dataPolicy: '/data-policy',
  communicationPreferences: '/communication-preferences',
  subscriptions: '/subscriptions',
  memberships: '/memberships',
  // Jira ticket ACCT-880 - All these products endpoint are deprecated
  // I was not secure to remove because it's used in many different places
  products: {
    default: '/products',
    direct: {
      default: '/products/direct',
      windows: '/products/direct/windows',
      android: '/products/direct/android'
    },
    muse: {
      trial: '/products/muse_trial',
      promo: '/products/muse_intro'
    },
    ms: {
      default: '/products/meditationstudio'
    }
  },
  checkoutSuccess: '/checkout/success',
  checkoutSuccessMeditationStudio: '/checkout/success/meditationstudio',
  signupSuccess: '/signup/success',
  redemptionActivate: '/activate',
  redemptionActivateSuccess: '/activate/success',
  activatePartner: '/activate_partner',
  activatePartnerSuccess: '/activate_partner/success'
};



// WEBPACK FOOTER //
// ./src/config/routes/endpoints.js